module.exports = __webpack_public_path__ + "static/img/background.9e953a0c.svg";